import React from 'react';
import {SpinnerProps} from '../../@types/components/Spinner';
import SpinnerChase from './SpinnerChase';
import {Spinner as BootstrapSpinner} from 'reactstrap';

export default class Spinner extends React.Component<SpinnerProps> {
    render() {
        if ([undefined, 'chase'].includes(this.props.type)) {
            return <SpinnerChase {...this.props}/>;
        }

        return <BootstrapSpinner {...this.props}/>;
    }
}
